import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
  Typography
} from "@material-ui/core";
import APIUsageCard from "../APIUsageCard";

import config from "../../../dashboard-config";

const useStyles = makeStyles(theme => ({
  page: {
    width: "100vw",
    height: "81vh",
    padding: theme.spacing(6)
  }
}));

type APIUsageItem = {
  id: string | number | undefined;
  product: string;
  current_usage: number;
};

const APIUsagePage: React.FC<{}> = () => {
  const classes = useStyles();
  const [apiUsageList, setApiUsageList] = useState<any[] | null>(null);

  useEffect(() => {
    const profile = JSON.parse(localStorage.getItem("sofar-user") || "{}");
    fetch(
      `${config.wavefleetUrl}/users/${profile.username}/subscriptionItems?include_current_usage=true`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
          token: profile.token
        })
      }
    )
      .then(res => res.json())
      .then(res => {
        setApiUsageList(res.subscriptionItems);
      });
  }, []);

  return (
    <Paper className={classes.page}>
      <Grid
        direction="row"
        justify="center"
        alignItems="center"
        spacing={1}
        container
      >
        <Grid xs={1} md={3} item></Grid>
        <Grid
          xs={10}
          md={3}
          container
          direction="column"
          alignItems="center"
          justify="center"
          spacing={2}
          item
        >
          <Grid item container>
            <Typography variant="h5">Calls This Month</Typography>
          </Grid>
          {apiUsageList !== null ? (
            <>
              {apiUsageList.length > 0 ? (
                apiUsageList.map((item: APIUsageItem) => (
                  <Grid key={item.id} item container>
                    <APIUsageCard
                      product={item.product}
                      current_usage={item.current_usage}
                    />
                  </Grid>
                ))
              ) : (
                <Grid item container>
                  <Typography variant="subtitle2">
                    Currently not subscribed to any products
                  </Typography>
                </Grid>
              )}
            </>
          ) : (
            <CircularProgress color="secondary" />
          )}
        </Grid>
        <Grid xs={1} md={6} item></Grid>
      </Grid>
    </Paper>
  );
};

export default APIUsagePage;
